var exports = {
  "H": "xaf9ae18d--8339e1--btn",
  "D": "xaf9ae18d--8339e1--title",
};

module.exports = exports;
